var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaskIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "13px",
    viewBox: "0 0 11 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Task Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "To-Do",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "View-To-Do---History",
    transform: "translate(-439.000000, -211.000000)",
    fill: "#838383",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Task-Icon",
    transform: "translate(439.354964, 211.004350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.7515335,1.00035096 L7.51572418,1.00035096 L7.51572418,0.5078125 C7.51572418,0.227325439 7.28839874,0 7.00791168,0 L3.0129547,0 C2.73246766,0 2.5051422,0.227325439 2.5051422,0.5078125 L2.5051422,1.00035096 L1.26953125,1.00035096 C0.569503797,1.00035096 0,1.56985474 0,2.26988221 L0,11.7304688 C0,12.4304962 0.569503797,13 1.26953125,13 L8.7515335,13 C9.45156098,13 10.0210648,12.4304962 10.0210648,11.7304688 L10.0210648,2.26988221 C10.0210648,1.56985474 9.4514618,1.00035096 8.7515335,1.00035096 L8.7515335,1.00035096 Z M6.50009918,1.015625 L6.50009918,2.00080108 L3.52066802,2.00080108 C3.52066802,1.66328429 3.52066802,1.38448334 3.52066802,1.015625 L6.50009918,1.015625 Z M9.00543975,11.7304688 C9.00543975,11.8705139 8.89147949,11.984375 8.7515335,11.984375 L1.26953125,11.984375 C1.12948608,11.984375 1.015625,11.8705139 1.015625,11.7304688 L1.015625,2.26988221 C1.015625,2.12993622 1.12948608,2.01597596 1.26953125,2.01597596 L2.50504302,2.01597596 L2.50504302,2.50861358 C2.50504302,2.78910064 2.73246766,3.01642608 3.01285552,3.01642608 L7.00791168,3.01642608 C7.28829956,3.01642608 7.51572418,2.78910064 7.51572418,2.50861358 L7.51572418,2.01597596 L8.7515335,2.01597596 C8.89147949,2.01597596 9.00543975,2.12993622 9.00543975,2.26988221 L9.00543975,11.7304688 Z M7.36685181,5.92920684 C7.56521606,6.1275711 7.56521606,6.44911957 7.36685181,6.64738466 L4.69825743,9.315979 C4.49999238,9.51434326 4.1784439,9.51434326 3.98007964,9.315979 L2.65391542,7.98981475 C2.45565034,7.7915497 2.45565034,7.47000122 2.65391542,7.27163696 C2.85227968,7.07337188 3.17372895,7.07337188 3.37209321,7.27163696 L4.33921815,8.23876191 L6.64867402,5.92930604 C6.84703828,5.73094179 7.16848755,5.73094179 7.36685181,5.92920684 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskIcon);
export default __webpack_public_path__ + "static/media/task-icon.1e604d91c11492995d1b0a99e390f467.svg";
export { ForwardRef as ReactComponent };